import { render, staticRenderFns } from "./SuperCollection.vue?vue&type=template&id=6641fe1f&scoped=true&lang=pug&"
import script from "./SuperCollection.vue?vue&type=script&lang=js&"
export * from "./SuperCollection.vue?vue&type=script&lang=js&"
import style0 from "./SuperCollection.vue?vue&type=style&index=0&id=6641fe1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6641fe1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6641fe1f')) {
      api.createRecord('6641fe1f', component.options)
    } else {
      api.reload('6641fe1f', component.options)
    }
    module.hot.accept("./SuperCollection.vue?vue&type=template&id=6641fe1f&scoped=true&lang=pug&", function () {
      api.rerender('6641fe1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/pages/SuperCollection/SuperCollection.vue"
export default component.exports